"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withForwardRef = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _core = require("@emotion/core");

var withForwardRef = function withForwardRef(Component) {
  var ForwardRef = _react.default.forwardRef(function (props, ref) {
    return (0, _core.jsx)(Component, (0, _extends2.default)({}, props, {
      ref: ref
    }));
  });

  var componentName = Component.displayName || Component.name;
  ForwardRef.propTypes = Component.propTypes; // eslint-disable-line react/forbid-foreign-prop-types

  ForwardRef.defaultProps = Component.defaultProps;
  ForwardRef.displayName = "ForwardRef.".concat(componentName);
  return ForwardRef;
};

exports.withForwardRef = withForwardRef;